import { TileLayer } from '@deck.gl/geo-layers';

import { renderBitmapTileSubLayer } from './renderBitmapTileSubLayer';

export const geoNamesLayers = {
  gisco:
    'https://gisco-services.ec.europa.eu/maps/wmts/OSMCartoV4LabelsCS/EPSG3857/{z}/{x}/{y}.png',
} as const;

type GeoNamesLayerUrl = typeof geoNamesLayers[keyof typeof geoNamesLayers];

export const geoNamesLayer = (layer: GeoNamesLayerUrl) =>
  new TileLayer({
    id: `geo-names-layer-${layer}`,
    data: layer,
    loadOptions: {
      mimeType: 'image/png',
    },
    maxRequests: 17,
    minZoom: 0,
    maxZoom: 18,
    tileSize: 256,
    opacity: 1,
    renderSubLayers: renderBitmapTileSubLayer,
  });
